module.exports = __webpack_public_path__ + "img/header.d17c1edf.jpg";